export default __webpack_public_path__ + "static/media/Join-list.50b01fdd.png";